import { render, staticRenderFns } from "./MediaForm.vue?vue&type=template&id=2a94b562&scoped=true&"
import script from "./MediaForm.vue?vue&type=script&lang=js&"
export * from "./MediaForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=2a94b562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94b562",
  null
  
)

export default component.exports